import { Container } from '@/components/Containers/Container';
import { Skeleton } from '@frontend/ui/components/skeleton';

export const MapSkeleton = () => {
	return (
		<Container className="h-full">
			<Skeleton className="h-full" />
		</Container>
	);
};
